// 02.7-settings.md paso c -- adelgazamiento de WhatsPanel.jsx. Los badges de tags detectados en
// el texto del composer (`activeSemanticTags`, ver `lib/semanticTags.js`). Solo el tag "Meet" es
// clickeable (abre `WhatsMeetPopup`).
export default function WhatsSemanticTagBadges({ tags, onMeetClick, onTaskClick }) {
  if (tags.length === 0) return null;
  return (
    <div style={{
      padding: "0 var(--space-4)",
      marginBottom: "9px",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "flex-end",
      gap: "5px",
      background: "transparent",
    }}>
      {tags.map((tag, i) => (
        <div key={i}
          onClick={() => {
            if (tag.label === "Meet") onMeetClick();
            if (tag.label === "Task") onTaskClick();
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "var(--space-1) 10px",
            backgroundColor: tag.color + "26",
            color: tag.color,
            border: `1px solid ${tag.color}40`,
            borderRadius: "var(--radius-xl)",
            fontSize: "12px",
            fontWeight: "600",
            cursor: (tag.label === "Meet" || tag.label === "Task") ? "pointer" : "default"
          }}>
          <span>{tag.icon}</span>
          <span>{tag.label}</span>
        </div>
      ))}
    </div>
  );
}
